import { StorageUtils } from "@/features/shared/storage/storage.utils";
import { signOutOfStaff } from "@/services/staff.services";

export default function useOnLogout() {
  return async (): Promise<void> => {
    StorageUtils.clear();
    // The staff session is saved in this browser: it must be gone before the reload, or it signs right back in.
    await signOutOfStaff().catch(() => undefined);
    window.location.href = "/";
  };
}
